import React, { useEffect, useState } from 'react'
import Select from '../../../Components/Autocompelte/Select'
import { SkyButton, SkyOutlinedButton } from '../../../Components/Buttons'
import CustomInput from '../../../Components/Input/CustomInput'
import {
  ALLOCATE_CAB_BOOKING,
  DEALLOCATE_CAB_BOOKING,
  GET_CAB_BY_FLEET_OWNER,
  GET_FLEET_DRIVERS_BY_OWNER_ID,
  START_CAB_BOOKING,
} from '../../../Services/cabggl'
import { useLazyQuery, useMutation } from '@apollo/client'
import DriverAutocomplete from '../../../Components/Autocompelte/driverAutocomplete'
import { toast } from 'react-toastify'
import { getDecryptedSessionStorageVariable } from '../../../utils/encryptStorage'
import DateTimePicker from '../../../Components/Input/DateTimePicker'

const StartDuty = ({ onClose, refetch, selectedBooking }) => {
  const [meterReading, setMeterReading] = useState('')
  const [allocateCabBooking, { data, loading: loadingAllocation, error }] =
    useMutation(ALLOCATE_CAB_BOOKING)

  const handleInputChange = (text) => {
    setMeterReading(text)
  }
  console.log('selectedBooking', selectedBooking)

  const [reportingDate, setReportingDate] = useState(new Date())
  const fleetid = getDecryptedSessionStorageVariable('fleetId')
  const [loadFleetDrivers] = useLazyQuery(GET_FLEET_DRIVERS_BY_OWNER_ID)
  const [loadFleetCabs] = useLazyQuery(GET_CAB_BY_FLEET_OWNER)
  const [
    deallocateCabBooking,
    {
      loading: loadingdeallocate,
      error: errorDeallocate,
      data: deallocateData,
    },
  ] = useMutation(DEALLOCATE_CAB_BOOKING)
  // const [reportingTime, setReportingTime] = useState(new Date())
  const [fleetDriverOptions, setFleetDriverOptions] = useState([])
  const [selectedDriver, setSelectedDriver] = useState({
    label: `${selectedBooking?.driverId?.firstName ?? ''} ${
      selectedBooking?.driverId?.lastName ?? ''
    } ${
      selectedBooking?.driverId?.mobileNumber
        ? `(${selectedBooking?.driverId?.mobileNumber})`
        : ''
    }`.trim(),
    value: selectedBooking?.driverId?._id,
  })
  const [selectedCab, setSelectedCab] = useState({
    label:
      selectedBooking.cabId?.variant && selectedBooking.cabId?.carNo
        ? `${selectedBooking.cabId?.variant ?? ''} (${
            selectedBooking.cabId?.carNo ?? ''
          })`.trim()
        : '',
    value: selectedBooking?.cabId?._id,
  })

  const [fleetCabOptions, setFleetCabOptions] = useState([])
  const fetchFleetDrivers = async () => {
    try {
      if (fleetid) {
        await loadFleetDrivers({
          variables: { fleetOwnerId: fleetid },
        }).then((res) => {
          const options = res?.data?.getDriverByFleetOwner?.map((driver) => ({
            label: `${driver.firstName ?? ''} ${driver.lastName ?? ''} ${
              driver.mobileNumber ? `(${driver.mobileNumber})` : ''
            }`.trim(),
            value: driver._id,
          }))
          setFleetDriverOptions(options)
        })
      } else {
        console.log('No FleetOwnerId available')
      }
    } catch (err) {
      console.error('Error fetching fleet drivers:', err)
    }
  }
  const fetchFleetCabs = async () => {
    try {
      if (fleetid) {
        await loadFleetCabs({
          variables: { fleetOwnerId: fleetid },
        }).then((res) => {
          const options = res?.data?.getCabByFleetOwner?.map((cab) => ({
            label:
              cab?.variant && cab?.carNo
                ? `${cab?.variant ?? ''} (${cab?.carNo ?? ''})`.trim()
                : '',
            value: cab?._id,
          }))
          setFleetCabOptions(options)
        })
      } else {
        console.log('No FleetOwnerId available')
      }
    } catch (err) {
      console.error('Error fetching fleet drivers:', err)
    }
  }
  useEffect(() => {
    fetchFleetDrivers()
    fetchFleetCabs()
  }, [])

  const [updateStartDuty, { loading }] = useMutation(START_CAB_BOOKING)
  const handleReportingDateUpdate = async () => {
    if (meterReading.startsWith('0') || meterReading === '') {
      toast.warn('reading should not start with 0')
      return
    }
    if (loading) {
      return
    }
    try {
      const { data } = await updateStartDuty({
        variables: {
          createCabBookingInput: {
            id: selectedBooking?.id,
            tentativeReportingDate: reportingDate,
            startingReading: Number(meterReading),
          },
        },
      })
      if (data) {
        toast.success('Duty started successfully')
        refetch()
        onClose(false)
      }
    } catch (error) {
      toast.error('Something went wrong')
      console.log('error', error)
    }
  }

  const handleAllocateCabBooking = async () => {
    if (!selectedDriver?.value || !fleetid || !selectedCab?.value) {
      return toast.warn('Please select fleet owner, driver and cab')
    }
    try {
      const response = await allocateCabBooking({
        variables: {
          createCabBookingInput: {
            id: selectedBooking?.id,
            driverId: selectedDriver?.value,
            cabId: selectedCab?.value,
            fleetOwnerId: fleetid,
            updatedBy: getDecryptedSessionStorageVariable('conUserId'),
            updatedName:
              getDecryptedSessionStorageVariable('userFirstName') +
              ' ' +
              getDecryptedSessionStorageVariable('userLastName'),
          },
        },
      })
      if (response?.data?.allocateCabBooking?.id) {
        toast.success('Driver and Cab allocated successfully')
        refetch()
      }
    } catch (err) {
      if (err?.message === 'Please Recharge Your Account') {
        toast.warn('Please recharge your account')
      }
    }
  }

  const handleDeallocate = async () => {
    try {
      const response = await deallocateCabBooking({
        variables: {
          bookingId: selectedBooking?.id,
          updatedBy: getDecryptedSessionStorageVariable('fleetId'),
          updatedName:
            getDecryptedSessionStorageVariable('userFirstName') +
            ' ' +
            getDecryptedSessionStorageVariable('userLastName'),
        },
      })
      if (response?.data?.deallocateCabBooking?.id) {
        onClose()
        toast.success('Driver and Cab deallocated successfully')
        refetch()
      }
    } catch (err) {
      console.error('Error deallocating cab booking:', err)
    }
  }

  return (
    <div>
      <div className="w-full justify-start flex gap-10 flex-col mt-2">
        <div className="w-full text-start max-w-96">
          <div>
            <div className="w-full max-w-md mx-auto">
              <DateTimePicker
                labelValue="Reporting Date And Time:"
                selectedDate={reportingDate}
                onDateChange={(date) => {
                  setReportingDate(date)
                }}
              />
            </div>
            <div className="mt-4">
              <CustomInput
                labelValue={'Enter Meter Reading'}
                value={meterReading}
                placeholderValue={'000000'}
                onChange={(text) => handleInputChange(text)}
              />
            </div>
            <div className="mt-4">
              <div className="w-full text-start max-w-96">
                <Select
                  selected={selectedDriver}
                  labelValue={'Select Driver'}
                  placeholderValue={'Select Driver'}
                  options={fleetDriverOptions}
                  onSelect={setSelectedDriver}
                />
              </div>
            </div>
            <div className="mt-4">
              <Select
                selected={selectedCab}
                labelValue={'Select Cab'}
                placeholderValue={'Select Cab'}
                options={fleetCabOptions}
                onSelect={setSelectedCab}
              />
            </div>
            <div className="mt-4 flex gap-2 justify-end">
              <SkyOutlinedButton
                label={'Remove Driver'}
                onClick={() => {
                  handleDeallocate()
                }}
              />
              <SkyOutlinedButton
                label={'Update Allocation'}
                onClick={() => {
                  handleAllocateCabBooking()
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex gap-2">
          <SkyButton
            label={'Start Duty'}
            onClick={() => {
              handleReportingDateUpdate()
            }}
          />
          <SkyOutlinedButton label={'Cancel'} onClick={() => onClose()} />
        </div>
      </div>
    </div>
  )
}

export default StartDuty
